export const macrolinks = [
    {
        title: "Real GDP",
        route: "gdp",
        description: "Real Gross Domestic Product Values",
    },
    {
        title: "Real GDP Growth Rates",
        route: "gdp-growth-rates",
        description: "Real Gross Domestic Product Growth Rates",
    },
    {
        title: "Real GDP Per Capita",
        route: "gdp-per-capita",
        description: "Real Gross Domestic Product Per Capita",
    },
    {
        title: "Real GDP Per Capita Change",
        route: "gdp-per-capita-change",
        description: "Real Gross Domestic Product Per Capita Change",
    },
    {
        title: "Nominal GDP",
        route: "nominal-gdp",
        description: "Nominal Gross Domestic Product Values",
    },
    // {
    //     title: "Nominal GDP Growth Rates",
    //     route: "nominal-gdp-growth-rates",
    //     description: "Nominal Gross Domestic Product Growth Rates",
    // },
    {
        title: "Nominal GDP Per Capita",
        route: "nominal-gdp-per-capita",
        description: "Nominal Gross Domestic Product Per Capita",
    },
    {
        title: "Population",
        route: "population",
        description: "Population Data & Statistics",
    },
    {
        title: "Employment",
        route: "employment",
        description: "Employment Data & Statistics",
    },
    // {
    //     title: "Unemployment",
    //     route: "unemployment",
    //     description: "Unemployment Data & Statistics",
    // },
    {
        title: "Public Expenditure",
        route: "public-expenditure",
        description: "The total expenditure",
    },
    {
        title: "Government Revenues",
        route: "government-revenues",
        description: "Government Revenues from taxes & other sources",
    },
    {
        title: "National Budget",
        route: "national-budget",
        description: "Annual National Budget",
    },
    {
        title: "National Debt",
        route: "national-debt",
        description: "Cumulative National Debt",
    },
    {
        title: "Balance of Payments",
        route: "balance-of-payments",
        description: "Total Balance of Payments",
    },
    {
        title: "Exchange Rates",
        route: "exchange-rates",
        description: "Official Nominal Currency Exchange Rates",
    },
];
